import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.after('initialize', function() {
        this.on(this.$node, 'uiClientDataRequested', this.getClientData);
    });

    this.getClientData = function(e, data) {
        if (data.ids.length === 0) return null;

        let xhr = $.ajax({
            url: data.url,
            type: 'GET',
            data: {
                'client-ids': data.ids,
            },
        });

        xhr.success(
            function(data) {
                this.trigger('dataClientsLoaded', data);
            }.bind(this)
        );
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/data/clients.js